import React, { useState, useContext } from "react";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { RiCloseCircleLine } from "react-icons/ri";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { showSuccess, showError } from "../../utils/toast";
import ButtonUI from "../material-ui/ButtonUI";
import updateEmailTemplateData from "../../api/updateEmailTemplateData";
import { AuthContext } from "../../context/Auth/AuthContext";

const EmailTemplateStatusPopup = ({
  setEmailTemplatesAddedToTrue,
  tableValues,
}) => {
  const [open, setOpen] = useState(false);
  const { token, user_id } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onStatusChangeSubmit = async () => {
    const response = await updateEmailTemplateData({
      token: token,
      userId: user_id,
      id: tableValues.id,
      status:
        tableValues.status.toLowerCase() === "active" ? "inactive" : "active",
    });

    if (response?.code === 200) {
      setEmailTemplatesAddedToTrue();
      setOpen(false);
      showSuccess("Email Template status changed successfully");
    } else {
      showError("Error while updating Email Template status");
    }
  };

  return (
    <div className="dialog-modal">
      <div
        role="button"
        tabIndex={0}
        aria-label="Change Status"
        title="Change Status"
        onClick={handleClickOpen}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClickOpen();
          }
        }}
        style={{
          color:
            tableValues.status.toLowerCase() === "inactive"
              ? "#e0a800"
              : "#28a745",
          backgroundColor:
            tableValues.status.toLowerCase() === "inactive"
              ? "rgba(255, 193, 7, 0.15)"
              : "rgba(40, 167, 69, 0.12)",
          borderColor:
            tableValues.status.toLowerCase() === "inactive"
              ? "rgba(255, 193, 7, 0.4)"
              : "rgba(40, 167, 69, 0.35)",
        }}
        className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-lg border"
      >
        {tableValues.status.toLowerCase() === "inactive" ? (
          <RiCloseCircleLine style={{ fontSize: 18 }} />
        ) : (
          <HiOutlineCheckCircle style={{ fontSize: 18 }} />
        )}
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            {tableValues.status.toLowerCase() === "inactive" ? (
              <HiOutlineCheckCircle />
            ) : (
              <RiCloseCircleLine />
            )}
          </div>
          <div className="popup-header-title">
            Change Email Template Status
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to change Email Template status?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            onClickFunc={() => {
              onStatusChangeSubmit();
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EmailTemplateStatusPopup;
